import React from "react"
import MyControlTypes from "src/core/components/MyControl/MyControlTypes"
import MyFormControlWrap from "src/core/components/MyForm/MyFormControlWrap"
import { HConstant, HUtils } from "src/core/helpers"
import {
  checkConditionShow,
  checkConditionShowWithOperator,
} from "src/core/helpers/utils"
import { HIs } from "@macashipo/mlib"

class V1PageMFCExt extends React.Component<IPropsMyFormControl> {
  _cControl: any = null
  constructor(props) {
    super(props)
    this.state = {}
    this.initExtControl()
  }

  componentDidMount() {}
  forceUpdateWithCurrentValue = () => {
    console.warn("forceUpdateWithCurrentValue", this._cControl)
    if (this._cControl && this._cControl.setValue) {
      let _valuesForm = this.getCurrentValuesOfForm()
      let _value = _valuesForm[this.getMyFieldName() || ""]
      if (_value !== null) {
        this._cControl.setValue(_value)
      }
    }
    this.forceUpdate()
  }
  updateValue = v => {
    if (this._cControl && this._cControl.setValue) {
      this._cControl.setValue(v)
    }
  }
  initExtControl = () => {
    let _fnList = this.getFnList()
    if (_fnList && _fnList.initExtControl) {
      _fnList.initExtControl(this.getMyFieldName(), {
        forceUpdate: () => {
          this.forceUpdate()
        },
        forceUpdateWithCurrentValue: () => {
          this.forceUpdateWithCurrentValue()
        },
        updateValueEffect: () => {
          console.warn("updateValueEffect:", this._cControl)
          if (this._cControl && this._cControl.setValue) {
            let _value = this.getEffectValue()
            if (_value !== undefined) {
              this._cControl.setValue(_value)
            }
          }
        },
        updateValue: v => {
          this.updateValue(v)
        },
      })
    }
  }
  getCanShow = (customConditionShow = null) => {
    let _conditionShow =
      customConditionShow || this.getConfigInMoreByKey("conditionShow", null)
    let _canShow = true
    if (_conditionShow) {
      let _currentValuesOfForm = {
        ...this.getDefaultValues(),
        ...this.getCurrentValuesOfForm(),
      }
      // console.warn("_currentValuesOfForm", _currentValuesOfForm)
      if (_conditionShow.isCondition) {
        let _valueRelative = HUtils.get(
          _currentValuesOfForm,
          _conditionShow.fieldRelative
        )
        _canShow = checkConditionShowWithOperator(
          _valueRelative,
          _conditionShow.whenValue,
          _conditionShow.operator,
          _conditionShow.formatDataToCmp
        )
      } else {
        let _keys = Object.keys(_conditionShow)
        for (let k of _keys) {
          let _checkOfKey = true
          if (_conditionShow[k]?.isCondition) {
            let fCompare = _conditionShow[k].fieldRelative
            if (!fCompare) {
              fCompare = k
            }
            _checkOfKey = checkConditionShowWithOperator(
              HUtils.get(_currentValuesOfForm, fCompare),
              _conditionShow[k].whenValue,
              _conditionShow[k].operator,
              _conditionShow[k].formatDataToCmp
            )
          } else {
            _checkOfKey = checkConditionShow(
              _currentValuesOfForm[k],
              _conditionShow[k]
            )
          }
          // console.warn("_conditionShow", _conditionShow, _checkOfKey)

          if (_checkOfKey === false) {
            return false
          }
          // if (HIs.isArray(_currentValuesOfForm[k])) {
          //   if (_currentValuesOfForm[k].indexOf(_conditionShow[k]) === -1) {
          //     return false
          //   }
          // } else if (_conditionShow[k] !== _currentValuesOfForm[k]) {
          //   return false
          // }
        }
      }
    }
    return _canShow
  }
  getCanDisplay = (customConditionShow = null) => {
    let _conditionShow =
      customConditionShow || this.getConfigInMoreByKey("conditionDisplay", null)
    let _canShow = true
    if (_conditionShow) {
      let _currentValuesOfForm = {
        ...this.getDefaultValues(),
        ...this.getCurrentValuesOfForm(),
      }
      // console.warn("_currentValuesOfForm", _currentValuesOfForm)
      if (_conditionShow.isCondition) {
        let _valueRelative = HUtils.get(
          _currentValuesOfForm,
          _conditionShow.fieldRelative
        )
        _canShow = checkConditionShowWithOperator(
          _valueRelative,
          _conditionShow.whenValue,
          _conditionShow.operator,
          _conditionShow.formatDataToCmp
        )
      } else {
        let _keys = Object.keys(_conditionShow)
        for (let k of _keys) {
          let _checkOfKey = true
          if (_conditionShow[k]?.isCondition) {
            let fCompare = _conditionShow[k].fieldRelative
            if (!fCompare) {
              fCompare = k
            }
            _checkOfKey = checkConditionShowWithOperator(
              HUtils.get(_currentValuesOfForm, fCompare),
              _conditionShow[k].whenValue,
              _conditionShow[k].operator,
              _conditionShow[k].formatDataToCmp
            )
          } else {
            _checkOfKey = checkConditionShow(
              _currentValuesOfForm[k],
              _conditionShow[k]
            )
          }
          // console.warn("_conditionShow", _conditionShow, _checkOfKey)

          if (_checkOfKey === false) {
            return false
          }
          // if (HIs.isArray(_currentValuesOfForm[k])) {
          //   if (_currentValuesOfForm[k].indexOf(_conditionShow[k]) === -1) {
          //     return false
          //   }
          // } else if (_conditionShow[k] !== _currentValuesOfForm[k]) {
          //   return false
          // }
        }
      }
    }
    return _canShow
  }
  getCurrentValuesOfForm = () => {
    let _fnList = this.getFnList()
    if (_fnList && _fnList.getCurrentValues) {
      return _fnList.getCurrentValues()
    }
    return {}
  }
  getMyType = () => {
    return ""
  }
  getMyControl = () => {
    return ""
  }
  getMyClassName = () => {
    return this.getMyType()
  }
  getFnList: any = () => {
    const { fnList } = this.props
    return fnList || {}
  }
  getConfigFormControl = () => {
    const { configFormControl } = this.props
    return configFormControl
  }
  getConfigFormControlByKey = (key, df) => {
    const configFormControl = this.getConfigFormControl()
    if (configFormControl && HUtils.objHasKey(configFormControl, key)) {
      return configFormControl[key]
    }
    return df
  }
  getConfigInMoreByKey = (key, df) => {
    let _more = this.getConfigFormControlByKey("more", {})
    if (_more && _more.hasOwnProperty(key)) {
      return _more[key]
    }
    return df
  }
  getDefaultValues = () => {
    let _fnList = this.getFnList()
    if (_fnList && _fnList.getDefaultValues) {
      return _fnList.getDefaultValues()
    }
    return this.getConfigFormControl().defaultValues || {}
  }
  getMyFieldName = () => {
    return this.getConfigFormControl().fieldName
  }
  getLabel = () => {
    return this.getConfigFormControl().label
  }
  getOptionKey = () => {
    return this.getConfigFormControl().more?.optionKey
  }
  getSourceList = () => {
    const fnList = this.getFnList()
    if (fnList && fnList.getSourceList) {
      return fnList.getSourceList()
    }
    return {}
  }
  getEffectValue = () => {
    let _effectedValue = this.getConfigInMoreByKey("effectedValue", null)
    if (_effectedValue) {
      if (HIs.isFunction(_effectedValue)) {
        return _effectedValue(
          this.getCurrentValuesOfForm(),
          this.getDefaultValues()
        )
      }
    }
    return null
  }
  getSourceData = () => {
    const sourceList = this.getSourceList()
    const optionKey = this.getOptionKey()
    if (sourceList && optionKey && sourceList[optionKey]) {
      return sourceList[optionKey]
    }
    // console.warn("getSourceData:", this.props, sourceList, optionKey)
    return []
  }
  getValue = () => {
    const defaultValues = this.getDefaultValues()
    const fieldName = this.getMyFieldName()
    // console.warn("getValue:", defaultValues, fieldName)
    if (defaultValues && fieldName) {
      return defaultValues[fieldName]
    }
  }
  getControlOpts = () => {
    const { configFormControl } = this.props
    const controlOpts = {
      fnList: this.getFnList(),
      sourceData: this.getSourceData(),
      hint: configFormControl.more?.hint,
      getDefaultValues: this.getDefaultValues,
      handleUpdateDefaultValues: (list: any) => {
        let _defaultValues = this.getDefaultValues()
        console.warn("handleUpdateDefaultValues:", list, _defaultValues)
        let _keys = Object.keys(list)
        if (_keys && _keys.length > 0) {
          for (let k of _keys) {
            if (_defaultValues[k] && typeof _defaultValues[k] === "object") {
              if (HIs.isArray(_defaultValues[k])) {
                _defaultValues[k].splice(0, 0, ...list[k])
              }
            } else {
              _defaultValues[k] = list[k]
            }
          }
        }
        console.warn(
          "handleUpdateDefaultValues result:",
          this.getDefaultValues()
        )
      },
      ...configFormControl.more,
    }
    return controlOpts
  }
  renderCellWithMyControl = type => {
    const { isGroupLayout, isFromGroup }: any = this.props
    const { label, fieldName } = this.getConfigFormControl()
    const canDisplay = this.getCanDisplay()
    return (
      <MyFormControlWrap
        className={canDisplay ? "" : "d-none"}
        control={MyControlTypes.Types[type]}
        controlOpts={this.getControlOpts()}
        value={this.getValue()}
        label={label}
        fieldName={fieldName}
        isCheckTypeControl={
          type.startsWith("checkbox") || type.startsWith("radio") ? true : false
        }
        isControlFirst={
          type.startsWith("checkbox") || type.startsWith("radio") ? true : false
        }
        onUpdateValue={(newValue, opts: any = null) => {
          // console.warn("onUpdateValue:", newValue)
          HUtils.runFuntion(
            this.getFnList(),
            HConstant.MyFormControl.FnList.onUpdateValue,
            [
              {
                fieldName: this.getMyFieldName(),
                newValue: newValue,
                opts: opts,
              },
            ]
          )
        }}
        onUpdateValueWithFieldName={(newValue, fieldName = "") => {
          // console.warn("onUpdateValue:", newValue)
          HUtils.runFuntion(
            this.getFnList(),
            HConstant.MyFormControl.FnList.onUpdateValue,
            [
              {
                fieldName: fieldName,
                newValue: newValue,
              },
            ]
          )
        }}
        onUpdateMulti={obj => {
          HUtils.runFuntion(
            this.getFnList(),
            HConstant.MyFormControl.FnList.onUpdateValueMulti,
            [obj]
          )
        }}
        innerRef={r => {
          if (!isGroupLayout || isFromGroup) {
            if (this.props.innerRef) {
              //for group, MyFormControl inside MyFormControl
              return this.props.innerRef(r)
            }
          }
          this._cControl = r
          // console.warn("innerRef:", r)
        }}
      ></MyFormControlWrap>
    )
  }
  renderCell() {
    let _type = this.getMyControl()
    // console.warn("_type:", _type, MyControlTypes.Types)
    if (_type && MyControlTypes.Types[_type]) {
      return this.renderCellWithMyControl(_type)
    }
    return <div className={this.getMyClassName()}>MyFormControl</div>
  }
  render() {
    let _canShow = this.getCanShow()
    // console.warn("canshow;", _canShow)
    if (_canShow === true) {
      return this.renderCell()
    }
    return <></>
  }
}

export default V1PageMFCExt
